"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Claim = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _classnames = _interopRequireDefault(require("classnames"));
var _selectors = require("../../../../store/selectors");
var _Tooltip = _interopRequireWildcard(require("../../../../../ui/Tooltip"));
var _Button = _interopRequireWildcard(require("../../../../../ui/Button"));
var _actions = require("../../../../store/actions");
var _Alert = _interopRequireWildcard(require("../../../../../ui/Alert"));
var _claim = _interopRequireDefault(require("./img/claim.svg"));
var _delete = _interopRequireDefault(require("./img/delete.svg"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var ClaimPure = function ClaimPure(_ref) {
  var basketID = _ref.basketID,
    _ref$isEnabledRemove = _ref.isEnabledRemove,
    isEnabledRemove = _ref$isEnabledRemove === void 0 ? false : _ref$isEnabledRemove,
    link = _ref.link,
    description = _ref.description,
    claimID = _ref.claimID,
    className = _ref.className;
  var ui = (0, _reactRedux.useSelector)(_selectors.getRemoveClaimFromBasketUi);
  var _useTranslation = (0, _reactI18next.useTranslation)('BASKET_EDIT_FORM'),
    t = _useTranslation.t;
  var dispatch = (0, _reactRedux.useDispatch)();
  var onRemoveClaim = (0, _react.useCallback)(function () {
    return dispatch((0, _actions.startRemoveClaimFromBasket)(basketID, claimID));
  }, [basketID, dispatch, claimID]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_styles.default.infoRow, className)
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: (0, _classnames.default)(_styles.default.icon, _styles.default.claimIcon),
    icon: _claim.default,
    theme: _Button.THEMES.TRANSPARENT
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.claimLink
  }, link ? /*#__PURE__*/_react.default.createElement("a", {
    href: link,
    rel: "noopener noreferrer",
    target: "_blank"
  }, description) : description), isEnabledRemove && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    content: t('DELETE_CLAIM_BUTTON'),
    placement: _Tooltip.PLACEMENTS.TOP,
    trigger: [_Tooltip.TRIGGERS.HOVER]
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    loading: ui.loading,
    className: _styles.default.icon,
    icon: _delete.default,
    onClick: onRemoveClaim
  })), ui.error && /*#__PURE__*/_react.default.createElement(_Alert.default, {
    type: _Alert.TYPES.ERROR
  }, ui.message));
};
ClaimPure.propTypes = {
  basketID: _propTypes.default.number.isRequired,
  claimID: _propTypes.default.number.isRequired,
  isEnabledRemove: _propTypes.default.bool,
  link: _propTypes.default.string,
  description: _propTypes.default.string
};
var Claim = exports.Claim = (0, _react.memo)(ClaimPure);